import {
	canManageSharedResource,
	type ISharedResource,
} from '@netx/core-shared-resource';
import {canShareWithTeam} from './canShareWithTeam';

export const canShareResourceWithTeam = (
	sharedResource?: ISharedResource,
): boolean => canManageSharedResource(sharedResource) && canShareWithTeam();
